module.exports = __webpack_public_path__ + "assets/img/23_27.742a2460.jpg";